<template>
    <div>
      <div class="profile-block__contacts">
        <div class="col-xs-12 profile-block__input-row">
          <div class="profile-block__label">Новый пароль*</div>
          <input type="password" class="inputbox" v-model="model.PASSWORD">
        </div>
        <div class="col-xs-12 profile-block__input-row">
          <div class="profile-block__label">Повторите пароль*</div>
          <input type="password" class="inputbox" v-model="model.PASSWORD_CONFIRM">
        </div>
        <div class="col-xs-12 profile-block__input-row">
          <div v-for="(error,k) in errors" :key="k" class="input-row__error">{{ error.title }}</div>
          <div v-show="success" class="input-row__success">Сохранено</div>
        </div>
        <div class="col-xs-12 profile-block__input-row">
          <a @click.prevent="changePassword()" class="btn btn--black btn--block btn--next btn--md">
            <span>Сохранить</span>
          </a>
        </div>
      </div>
      <profile-footer-menu></profile-footer-menu>
    </div>
</template>

<script>
    import api from "@/api/profile";
    import ProfileFooterMenu from "@/components/Personal/ProfileFooterMenu";

    export default {
        name: 'ProfileChangePassword',
        components: {
          ProfileFooterMenu
        },
        data() {
          return {
            model: {
              PASSWORD:'',
              PASSWORD_CONFIRM:'',
            },
            errors: [],
            success: false,
          }
        },
        methods: {
          changePassword() {
            this.errors = [];
            this.success = false;

            api.changePassword(this.model, responseData => {
                  if (responseData.errors) {
                    this.errors = responseData.errors;
                  } else {
                    this.success = true;
                  }
                },
                err => this.errors = [{'title': err}]
            );
          }
        },
    }
</script>